import type {
  BackerRewardsState,
  BackerRewardsView,
} from '@/components/market/backer-rewards/backer-rewards-card-view';

export type BackerRewardsPlacement = 'below-prize-pool' | 'backers-tab';

interface ResolveBackerRewardsStateParams {
  canClaim: boolean;
  hasClaimed: boolean;
  isBacker: boolean;
  isPending: boolean;
}

interface BackerRewardsSnapshot extends ResolveBackerRewardsStateParams {
  headlineAmount: number;
  earnedAmount: number;
  earnedD6: string;
  userSharePct: number;
  isClaiming: boolean;
  claim: () => void;
}

export function resolveBackerRewardsState({
  canClaim,
  hasClaimed,
  isBacker,
  isPending,
}: ResolveBackerRewardsStateParams): BackerRewardsState {
  if (isPending) return 'loading';
  if (canClaim) return 'claimable';
  if (hasClaimed) return 'backer-claimed';
  return isBacker ? 'backer-unresolved' : 'non-backer';
}

export function resolveBackerRewardsPlacement(
  state: BackerRewardsState,
): BackerRewardsPlacement | null {
  if (state === 'loading') return null;
  return state === 'non-backer' ? 'backers-tab' : 'below-prize-pool';
}

export function createBackerRewardsView(rewards: BackerRewardsSnapshot): BackerRewardsView {
  return {
    state: resolveBackerRewardsState(rewards),
    headlineAmount: rewards.headlineAmount,
    earnedAmount: rewards.earnedAmount,
    earnedD6: rewards.earnedD6,
    userSharePct: rewards.userSharePct,
    isClaiming: rewards.isClaiming,
    onClaim: rewards.claim,
  };
}
